export const password = `${process.env.REACT_APP_DECRYPTO_ENCRYPTO_ELAKAY}`
export const elakay_API1 = `${process.env.REACT_APP_API_URL}`
export const elakay_API = `${process.env.REACT_APP_API_URL}`
export const REACT_PK = `${process.env.REACT_APP_API}`
export const ELAKAY_URl = `${process.env.REACT_APP_ELAKAY_URL}`
// export const ELAKAY_URl1 = `${process.env.ELAKAY_URL}`
export const ELAKAY_URl1 = "http://localhost:3000"
export const FirtIDCategory = "5ed4946fd2ba8812c20261a8"

